// Copyright (C) 2020 TANNER AG

import { graphql } from "react-apollo";
import { compose } from "recompose";
import withLocalization from "./withLocalization";
import withFlattenedTranslations from "./withFlattenedTranslations";
import withLoadingState from "./withLoadingState";
import withErrorState from "./withErrorState";
import withConnectionStatus from "./withConnectionStatus";
import tSTopicQuery from "../queries/tSTopic";

const buildQueryOptions = ({ slug, language, fetchPolicy, stage }) => {
    return {
        variables: {
            slug,
            stage,
            lang: language.toLowerCase(),
        },
        fetchPolicy,
    };
};

export default (customLoadingComponent) =>
    compose(
        withConnectionStatus,
        withLocalization,
        graphql(tSTopicQuery, {
            options: (props) => {
                return buildQueryOptions(props);
            },
        }),
        withErrorState,
        withLoadingState("tSTopic", customLoadingComponent, customLoadingComponent),
        withFlattenedTranslations("tSTopic")
    );



// WEBPACK FOOTER //
// ./src/hocs/withTSTopic.js